module.exports = function store(state, emitter) {
  emitter.on("set-playing-tutorial", (playingTutorial) => {
    if (state.tutorialComplete) {
      playingTutorial = false;
    }
    state.playingTutorial = playingTutorial;
    emitter.emit("render");
  });

  emitter.on("skip-tutorial", () => {
    state.playingTutorial = false;
    state.tutorialComplete = true;
    state.currentTutorial = null;
    state.currentInterrupt = null;
    state.displayingInterrupt = false;
    state.allowStageVariablesInTutorial = false;
    state.isMenuOpen = false;
    emitter.emit("render");
  });

  emitter.on("afterupdate", () => {});

  function doesTriggerMatch(eventname, data, data2, data3, trigger) {
    // Helper function to check if data matches the trigger's event_data
    function dataMatches(triggerData, actualData) {
      // If no trigger data specified, always match
      if (triggerData === undefined) return true;

      // If trigger data is an array, check if actual data is included
      if (Array.isArray(triggerData)) {
        return triggerData.includes(actualData);
      }

      // If trigger data is a single value, do exact match
      return triggerData === actualData;
    }

    return (
      trigger.event_name === eventname &&
      dataMatches(trigger.event_data, data) &&
      dataMatches(trigger.event_data2, data2) &&
      dataMatches(trigger.event_data3, data3)
    );
  }

  const IGNORED_EVENTS = [
    "render",
    "mousemove",
    "game-step",
    "set-playing-tutorial",
    "tutorial-char-tick",
    "play-mouse-move",
    "clear-hovering-target",
    "play-mouse-up",
    "play-mouse-down",
    "highlight-hover-target",
  ];

  emitter.on("*", (eventname, data, data2, data3) => {
    if (!state.playingTutorial || IGNORED_EVENTS.includes(eventname)) return;
    if (
      state.currentTutorial &&
      state.currentTutorial[state.currentTutorialStep]
    ) {
      const nextTriggers =
        state.currentTutorial[state.currentTutorialStep].nextTriggers;
      const trigger = nextTriggers.find((trigger) =>
        doesTriggerMatch(eventname, data, data2, data3, trigger)
      );
      if (trigger) {
        state.displayingInterrupt = false;
        let previousTemp = state.currentTutorialStep;
        if (trigger.nextStepId === "previous") {
          state.currentTutorialStep = state.previousTutorialStep;
        } else if (!trigger.nextStepId) {
          state.playingTutorial = false;
          state.tutorialComplete = true;
          state.currentTutorial = null;
          state.allowStageVariablesInTutorial = false;
          emitter.emit("render");
          return;
        } else {
          state.currentTutorialStep = trigger.nextStepId;
        }
        state.previousTutorialStep = previousTemp;
        state.currentTutorialCharIndex = 0;
        if (state.currentTutorial[state.currentTutorialStep].toolbar) {
          state.toolbar =
            JSON.parse(JSON.stringify(state.currentTutorial[state.currentTutorialStep].toolbar))  ;
        }
        if (
          state.currentTutorial[state.currentTutorialStep]
            .allowStageVariablesInTutorial !== undefined
        ) {
          state.allowStageVariablesInTutorial =
            state.currentTutorial[
              state.currentTutorialStep
            ].allowStageVariablesInTutorial;
        } else {
          state.allowStageVariablesInTutorial = false;
        }
        if (state.currentTutorial[state.currentTutorialStep].timer) {
          const timer = state.currentTutorial[state.currentTutorialStep].timer;
          setTimeout(() => {
            const eventName = timer.emit_event.split(" ")[0];
            const otherArguments = timer.emit_event.split(" ").slice(1);

            emitter.emit(eventName, ...otherArguments);
          }, timer.time);
        }

        if (trigger.emit_event) {
          const eventName = trigger.emit_event.split(" ")[0];
          const otherArguments = trigger.emit_event.split(" ").slice(1);
          emitter.emit(eventName, ...otherArguments);
        }
        state.displaying = false;
        clearTimeout(state.charTickTimeout);
        state.charTickTimeout = null;
        addDiscardedGlitchesToToolbar(state);
        emitter.emit("render");
      }
    }
    // interrupts are in the dictionary like normal steps, but they have the isInterrupt flag set to true
    if (state.currentTutorial && !state.displayingInterrupt) {
      Object.keys(state.currentTutorial).forEach((step) => {
        if (state.currentTutorial[step].isInterrupt) {
          const interrupt = state.currentTutorial[step];
          // Use the same trigger matching logic for interrupts
          if (doesTriggerMatch(eventname, data, data2, data3, interrupt)) {
            state.currentTutorialCharIndex = 0;

            state.previousTutorialStep = state.currentTutorialStep;
            state.currentTutorialStep = step;
            state.displayingInterrupt = true;
            if (interrupt.allowStageVariablesInTutorial !== undefined) {
              state.allowStageVariablesInTutorial =
                interrupt.allowStageVariablesInTutorial;
            } else {
              state.allowStageVariablesInTutorial = false;
            }
            // Removed automatic dismiss trigger - users must use nextTriggers or reset/rewind
            state.charTickTimeout = null;
            addDiscardedGlitchesToToolbar(state);
            emitter.emit("render");
          }
        }
      });
    }
  });

  emitter.on("tutorial-char-tick", () => {
    state.currentTutorialCharIndex++;
    clearTimeout(state.charTickTimeout);

    state.charTickTimeout = null;

    emitter.emit("render");
  });
};

function addDiscardedGlitchesToToolbar(state) {
  ("addDiscardedGlitchesToToolbar");
  const discardedGlitchApplications = state
    .getHistory()
    .filter(
      (historyItem) => historyItem.actionType === "remove-glitch-application"
    );
  discardedGlitchApplications.forEach((historyItem) => {
    if (!state.toolbar.glitches.includes(historyItem.metadata.glitchId)) {
      state.toolbar.glitches.push(historyItem.metadata.glitchId);
    }
  });
}
